import { Alert, Button, Checkbox, Form, Input, Select, Card, List, Row, Col } from 'antd'
import { getTrainingIds, getTrainingInfo, predict } from './helpers'
import { useState, useEffect } from 'react'
import './index.scss'
{ Option } = Select

PredictML = ({ service: { name } }) ->

  [dryRun, setDryRun] = useState(true)
  [idList, setIdList] = useState([])
  [loading, setLoading] = useState(false)
  [hasErr, setHasErr] = useState(false)
  [feedback, setFeedback] = useState([])
  [complexJSON, setComplexJSON] = useState(false)

  useEffect( ->
    init()
    undefined
  , [])

  init = ->
    setLoading(true)
    try
      ids = JSON.parse(await getTrainingIds('false', name))
      setIdList(ids)
    catch e
      setFeedback({ message: e.message })
      setHasErr(true)
    setLoading(false)

  onFinish = ({ queryType, queryBody, trainingId }) ->
    setFeedback([])
    setHasErr(false)
    try
      prediction = await predict({ queryType, queryBody, trainingId, dryRun, name })
      trainingInfo = JSON.parse(await getTrainingInfo({ trainingId, name }))
      if trainingInfo.mlAction.includes('Classification') then setComplexJSON(true) else setComplexJSON(false)
      if dryRun
        predictionList = _.map(JSON.parse(prediction), (value, key) ->
          title: key
          content: if complexJSON then JSON.parse(value.replace(/'/g, '"')) else value
        )
        setFeedback(predictionList)
      else
        prediction
    catch e
      setHasErr(true)
      setFeedback("#{e.message}")

  renderPrediction = (
    <div>
      <List
        grid={{ gutter: 16, column: 2 }}
        dataSource={feedback}
        renderItem={(item) =>
          <List.Item>
            <Card title={item.title}>
              {
                if complexJSON
                  (
                    <Row>
                    {
                      _.map(item.content, (value, key) ->
                        <Col>
                          <Card key={key} title={key}>{ value }</Card>
                        </Col>
                      )
                    }
                    </Row>
                  )
                else
                  item.content
              }
            </Card>
          </List.Item>
        }
      />
    </div>
  )

  # TODO: add dryRun form field
  <div className="ml-form-container">
    <Form
      className="ml-action-form"
      onFinish={onFinish}
    >
      <Form.Item
        name="trainingId"
        rules={[{ required: true, message: 'Training ID required' }]}
      >
        <Select
          showSearch
          placeholder={if loading then "Please Wait" else "Select a Training ID"}
          optionFilterProp="children"
          filterOption={(input, option) ->
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {
            if not loading then idList.map((id) ->
              <Option value={id} key="ml-status-#{id}">
                { id }
              </Option>
            )
          }
        </Select>
      </Form.Item>
      {
        if feedback.length > 0
          <Alert
            style={{marginBottom: '24px', maxHeight: '300px', overflow: 'scroll'}}
            message={if hasErr then "Error Occured" else "Success"}
            description={ if hasErr then feedback else renderPrediction }
            type={ if hasErr then "error" else "success" }
            closable
            onClose={ ->
              if hasErr then setHasErr(false)
              setFeedback([])
            }
          />
        else
          <>
            <Form.Item name="queryBody">
              <Input.TextArea
                placeholder="Provide a Weaver Query defining the dataset on which the prediction will apply. If left empty, it will use the entire Space dataset."
                autoSize={{ minRows: 8 }}
                type="text"
              />
            </Form.Item>
          </>
      }
      <Form.Item name="predictButton">
        <Button htmlType="submit">
          Predict
        </Button>
      </Form.Item>
    </Form>
  </div>

export default PredictML
